/* eslint-env browser */
/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import IdleTimer from 'react-idle-timer';
import { Logout, getUserCustomers, ResetPassword, refreshToken } from '../../actions/UserActions';
import {
    updateSecondaryAccounts,
    updateSelectedSecondaryAccountValue,
    getCustomData,
    clearSelectedInvoices
} from '../../actions/InvoiceActions';
import NavAccountSelect from "./NavAccountSelect";
import { getSelectedPrimaryAccount, hasDeposits } from "../invoice/Selectors";
import Drawer from '@material-ui/core/Drawer';
import MenuDrawer from "./MenuDrawer";
import Logo from "../Logo";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: true,
            drawerIsOpen: false,
        };

        this.navLinkClick = this.navLinkClick.bind(this);
        this.navLinkLogoutClick = this.navLinkLogoutClick.bind(this);
        this.navLinkResetPasswordClick = this.navLinkResetPasswordClick.bind(this);
        this.mapTableDropdownItems = this.mapTableDropdownItems.bind(this);

        this.idleTimer = null;
        this.onAction = this.onAction.bind(this)
        this.onIdle = this.onIdle.bind(this)
        this.toggleDrawer = this.toggleDrawer.bind(this)
    }

    componentDidMount() {
        getUserCustomers(this.props.dispatch);
        getCustomData(this.props.dispatch);
    }

    mapTableDropdownItems = (dropdownItems) => {
        if (dropdownItems) {
            const accountType = this.props.accountType;
            let secondaryAccounts = [];
            if (accountType === 'Payer') {
                secondaryAccounts = dropdownItems.map(subItem => ({
                    value: subItem.PrimaryAcct,
                    label: `${subItem.PrimaryAcct}${'-'}${subItem.Name}`,
                    clearableValue: false,
                    className: 'truncate',
                    checked: 'checked',
                }));
            } else {
                secondaryAccounts = dropdownItems.map(subItem => ({
                    value: subItem.PrimaryAcct,
                    label: `${subItem.PrimaryAcct}${'-'}${subItem.Name}`,
                    clearableValue: false,
                    className: 'truncate',
                    checked: '',
                }));
            }
            updateSecondaryAccounts(this.props.dispatch, secondaryAccounts);
            updateSelectedSecondaryAccountValue(this.props.dispatch, secondaryAccounts[0]);
        }
    };

    navLinkInvoiceClick = () => {
        this.setState({ collapsed: true });
    };

    navLinkClick = () => {
        clearSelectedInvoices(this.props.dispatch);
        this.setState({ collapsed: true });
    };

    navLinkLogoutClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({ collapsed: true });
        sessionStorage.setItem('impersonatedUserId', "");
        Logout(this.props.dispatch);
    };

    navLinkResetPasswordClick = () => {
        this.setState({ collapsed: true });
        ResetPassword(this.props.dispatch);
    };

    navBarToggleClick = () => {
        this.setState({ collapsed: !this.state.collapsed });
    };

    toggleDrawer = (isOpen) => {
        this.setState({ drawerIsOpen: isOpen });
    };

    onAction(e) {
        // Refresh Token
        refreshToken(this.props.dispatch);
    }

    onIdle(e) {
        toast.info("Session timeout occured, Please log in again.", { position: toast.POSITION.TOP_RIGHT, autoClose: false });
        Logout(this.props.dispatch);
    }

    render() {
        let collapsedClass = `${'collapse navbar-collapse webar-navbar-collapse'}`;

        if (!this.state.collapsed) {
            collapsedClass = 'navbar-collapse webar-navbar-collapse';
        }
        return (
            <IdleTimer
                ref={ref => {
                    this.logoutTimer = ref
                }}
                element={document}
                onAction={this.onAction}
                throttle={1000 * 60 * 5}
                onIdle={this.onIdle}
                timeout={1000 * 60 * 30}>
                <Drawer open={this.state.drawerIsOpen} onClose={() => this.toggleDrawer(false)}>
                    <MenuDrawer onClose={() => this.toggleDrawer(false)} />
                </Drawer>
                <nav id="appHeader" className="webar-navbar navbar fixed-top navbar-expand-lg navbar-light">
                    <div className="container">
                        <button className="navbar-toggler" type="button" onClick={() => this.toggleDrawer(true)}>
                            <span className="navbar-toggler-icon" />
                        </button>
                        <div className={collapsedClass} id="navbarSupportedContent">
                            <ul className="navbar-nav mr-auto">
                                <Logo height={50} header={true} />
                                <NavAccountSelect />
                            </ul>
                            <ul className="navbar-nav ml-auto">
                                <li className="nav-item">
                                    <NavLink to="/invoices" className="nav-link" exact={true} activeClassName={"active"}
                                        onClick={this.navLinkClick}>
                                        <span>Invoices</span>
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to="/invoices/invoicesearch" exact={true} className="nav-link" activeClassName={"active"}
                                        onClick={this.navLinkClick}>
                                        <span>Statement</span>
                                    </NavLink>
                                </li>
                                {this.props.hasDeposits && <li className="nav-item">
                                    <NavLink to="/deposits" className="nav-link" activeClassName={"active"} onClick={this.navLinkClick}>
                                        <span>Deposits</span>
                                    </NavLink>
                                </li>}
                                <li className="nav-item align-self-baseline align-self-lg-center">
                                    <a href="/ePay_Help.pdf" className="nav-link" activeClassName={"active"} onClick={this.navLinkClick}>
                                        <span className="small-text">Help</span>
                                    </a>
                                </li>
                                <Link to={'/settings/profile'} className={"align-self-baseline align-self-lg-center"}>
                                    <FontAwesomeIcon icon={faCog} size={"2x"} />
                                </Link>
                                <li className="nav-item align-self-baseline align-self-lg-center"
                                    title={"You are logged in as " + (this.props.currentUser && this.props.currentUser.Login ? this.props.currentUser.Login : '')}>
                                    <a className="nav-link" href="" onClick={this.navLinkLogoutClick}>
                                        <span className="small-text">Logout</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </IdleTimer>
        );
    }
}

Header.propTypes = {
    dispatch: PropTypes.func.isRequired,
};

export default withRouter(connect((state, props) => ({
    currentUser: state.default.currentUser,
    accountType: state.user_options.accountType,
    selectedPrimaryAccount: getSelectedPrimaryAccount(state, props),
    hasDeposits: hasDeposits(state, props),
}))(Header));
